/**
 * Created with IntelliJ IDEA.
 * User: tomers
 * Date: 7/28/13
 * Time: 4:53 PM
 * To change this template use File | Settings | File Templates.
 */
define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var INPUT_TYPE = {
        Text : 'text',
        Password : 'password'
    };
    var InputFieldModel = Backbone.Model.extend({
        defaults : {
            type : INPUT_TYPE.Text,
            minLength : 0,
            maxLength : 2000,
            validator : null,
            placeholder : '',
            name : 'value',
            tabindex : '',
            autofocus : false,
            enabled : true,
            readonly: false
        }
    });

    InputFieldModel.Type = INPUT_TYPE;

    return InputFieldModel;
});
